'use client';

import createSvg from '~/public/static/svg/createSvg';

export const AcceptanceItems = createSvg(props => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 646 608"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      maxWidth: 600,
    }}
  >
    <g clipPath="url(#clip0_155_2643)">
      <circle cx="590.681" cy="486.586" r="55.3194" fill="#F2FCF8" />
      <rect
        x="558.28"
        y="469.688"
        width="64.3511"
        height="49.0724"
        rx="8.5676"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <rect
        x="558.28"
        y="484.239"
        width="64.3511"
        height="2.50882"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M580.621 479.146H600.29C601.78 479.146 602.987 480.354 602.987 481.843V483.838H577.924V481.843C577.924 480.354 579.132 479.146 580.621 479.146Z"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M551.731 487.463L551.731 479.886C551.731 479.478 552.063 479.146 552.472 479.146L557.878 479.146L557.878 488.203L552.472 488.203C552.063 488.203 551.731 487.872 551.731 487.463Z"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M629.179 479.886L629.179 487.463C629.179 487.871 628.848 488.203 628.439 488.203L623.033 488.203L623.033 479.146L628.439 479.146C628.848 479.146 629.179 479.477 629.179 479.886Z"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M624.65 479.309V465.812C624.65 460.408 620.269 456.027 614.866 456.027H566.044C560.64 456.027 556.26 460.408 556.26 465.812V479.309"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M626.833 479.309V464.934C626.833 458.809 621.869 453.845 615.744 453.845H565.167C559.042 453.845 554.078 458.809 554.078 464.934V479.309"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
    </g>
    <g clipPath="url(#clip1_155_2643)">
      <circle cx="590.681" cy="270.953" r="55.3194" fill="#F2FCF8" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M591.642 249.436L613.926 264.745C620.675 273.561 624.1 284.137 624.216 296.467H559.07C559.191 284.715 562.574 274.138 569.223 264.739L591.642 249.436Z"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M591.639 240.47L610.025 258.449L613.843 264.637C620.647 273.475 624.099 284.087 624.216 296.467H559.07C559.191 284.666 562.602 274.051 569.305 264.622L572.974 258.447L591.639 240.47Z"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M591.81 263.049L591.81 291.273"
        stroke="#02C874"
        strokeWidth="1.12897"
        strokeLinecap="square"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M597.554 262.495C598.558 262.495 599.502 262.824 600.269 263.394C601.036 263.964 601.625 264.774 601.917 265.737L607.866 285.336C608.232 286.544 608.076 287.787 607.527 288.82C606.978 289.853 606.035 290.675 604.831 291.043C604.4 291.174 603.953 291.241 603.503 291.241H578.48C577.221 291.241 576.081 290.729 575.255 289.902C574.43 289.074 573.919 287.931 573.919 286.668C573.919 286.217 573.986 285.768 574.117 285.336L580.066 265.737C580.358 264.774 580.947 263.964 581.714 263.394C582.481 262.824 583.425 262.495 584.429 262.495H597.554Z"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
    </g>
    <g clipPath="url(#clip2_155_2643)">
      <circle cx="590.681" cy="55.3206" r="55.3194" fill="#F2FCF8" />
      <path
        d="M551.849 74.146C550.383 69.882 553.439 65.41 557.944 65.2263L593.732 63.7673C604.051 63.7673 611.789 58.6082 613.509 51.7293C615.11 45.3268 637.567 -49.7181 640.67 -62.8504C640.884 -63.757 641.682 -64.3511 642.614 -64.3511V-64.3511C643.895 -64.3511 644.856 -63.2001 644.583 -61.9479C641.122 -46.0744 621.584 43.4215 618.452 55.1688C615.012 68.0666 613.509 83.5436 604.229 85.237L578.132 89.7171C566.738 91.6731 555.607 85.0786 551.849 74.146V74.146Z"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="559.195"
        y1="72.0078"
        x2="593.426"
        y2="70.2962"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M562.604 76.8516L596.877 74.2832"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M566.026 81.9861L599.444 79.4177"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M598.589 64.0141L609.873 82.4147"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <circle
        cx="564.715"
        cy="44.0297"
        r="10.7252"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <circle
        cx="564.715"
        cy="37.2557"
        r="1.69345"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <circle
        cx="564.715"
        cy="44.0297"
        r="1.69345"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <circle
        cx="570.359"
        cy="47.4166"
        r="1.69345"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <circle
        cx="570.359"
        cy="40.6427"
        r="1.69345"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <circle
        cx="559.07"
        cy="47.4166"
        r="1.69345"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <circle
        cx="559.07"
        cy="40.6427"
        r="1.69345"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <circle
        cx="564.715"
        cy="50.8033"
        r="1.69345"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
    </g>
    <g clipPath="url(#clip3_155_2643)">
      <circle cx="412.304" cy="486.586" r="55.3194" fill="#F2FCF8" />
      <path
        d="M393.547 481.101V522.792H429.932V481.101M393.547 514.454L385.209 512.18"
        stroke="#02C874"
        strokeWidth="1.12897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M385.209 512.18V472.763C386.472 470.489 390.818 465.941 398.095 465.941C403.401 467.457 409.465 469.731 411.739 470.489C411.739 470.489 421.594 466.699 425.384 465.941C433.722 465.941 438.27 472.005 438.27 472.005V512.18L429.932 514.454"
        stroke="#02C874"
        strokeWidth="1.12897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M386.725 512.938V515.97L393.547 518.244"
        stroke="#02C874"
        strokeWidth="1.12897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M435.996 512.938V515.97L429.931 518.244"
        stroke="#02C874"
        strokeWidth="1.12897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M392.031 466.699C394.305 460.635 400.369 458.361 400.369 458.361H422.352C422.352 458.361 428.416 459.877 431.448 466.699"
        stroke="#02C874"
        strokeWidth="1.12897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M400.369 458.361L411.739 470.489L423.11 459.119"
        stroke="#02C874"
        strokeWidth="1.12897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip4_155_2643)">
      <circle cx="412.304" cy="270.953" r="55.3194" fill="#F2FCF8" />
      <mask
        id="mask0_155_2643"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x="439"
        y="267"
        width="16"
        height="16"
      >
        <circle
          cx="446.617"
          cy="274.617"
          r="7.61718"
          transform="rotate(-90 446.617 274.617)"
          fill="black"
        />
      </mask>
      <g mask="url(#mask0_155_2643)">
        <circle
          cx="446.617"
          cy="274.617"
          r="7.05269"
          transform="rotate(-90 446.617 274.617)"
          stroke="#02C874"
          strokeWidth="1.12897"
        />
        <circle
          cx="446.617"
          cy="266.048"
          r="7.05269"
          transform="rotate(-90 446.617 266.048)"
          stroke="#02C874"
          strokeWidth="1.12897"
        />
        <circle
          cx="446.617"
          cy="283.187"
          r="7.05269"
          transform="rotate(-90 446.617 283.187)"
          stroke="#02C874"
          strokeWidth="1.12897"
        />
      </g>
      <path
        d="M424.792 237.153C425.366 238.147 425.959 239.986 426.444 242.422C426.926 244.843 427.293 247.81 427.435 251.027C427.721 257.471 427.105 264.869 424.759 270.896C422.751 276.057 419.993 280.517 417.123 285.157C416.621 285.968 416.116 286.786 415.611 287.613C412.457 292.776 409.326 298.306 407.127 305.288C404.796 298.063 401.836 292.613 398.804 287.544C398.146 286.443 397.485 285.361 396.827 284.284C394.236 280.045 391.691 275.879 389.503 270.877C386.785 264.667 386.214 257.28 386.616 250.891C386.816 247.7 387.259 244.771 387.792 242.379C388.327 239.976 388.946 238.147 389.485 237.139C390.614 235.029 392.14 232.634 394.807 230.759C397.469 228.886 401.315 227.5 407.135 227.5C412.954 227.5 416.755 228.886 419.394 230.757C422.041 232.634 423.568 235.03 424.792 237.153Z"
        stroke="#02C874"
      />
      <path
        d="M423.057 238.869C423.572 239.756 424.107 241.402 424.546 243.591C424.981 245.765 425.313 248.429 425.441 251.32C425.699 257.109 425.142 263.753 423.024 269.163C421.209 273.798 418.716 277.804 416.12 281.975C415.666 282.705 415.208 283.44 414.751 284.185C411.918 288.793 409.104 293.73 407.114 299.948C405.011 293.515 402.349 288.65 399.625 284.123C399.029 283.132 398.43 282.159 397.835 281.19C395.491 277.379 393.191 273.637 391.212 269.143C388.758 263.571 388.241 256.938 388.605 251.198C388.786 248.332 389.186 245.701 389.668 243.553C390.151 241.394 390.71 239.755 391.195 238.855C392.214 236.962 393.59 234.816 395.994 233.136C398.394 231.459 401.864 230.214 407.122 230.214C412.38 230.214 415.809 231.459 418.187 233.135C420.573 234.816 421.95 236.962 423.057 238.869Z"
        stroke="#02C874"
      />
      <line x1="406.984" y1="230" x2="406.984" y2="311" stroke="#02C874" />
      <line
        x1="400.036"
        y1="231.572"
        x2="400.036"
        y2="284.857"
        stroke="#02C874"
        strokeLinecap="round"
      />
      <line
        x1="413.5"
        y1="231.5"
        x2="413.5"
        y2="285.5"
        stroke="#02C874"
        strokeLinecap="round"
      />
      <line
        x1="394.607"
        y1="234.286"
        x2="394.607"
        y2="275.357"
        stroke="#02C874"
        strokeLinecap="round"
      />
      <line
        x1="420.5"
        y1="235.5"
        x2="420.5"
        y2="274.5"
        stroke="#02C874"
        strokeLinecap="round"
      />
      <path
        d="M408.571 314.665V337.786H405.5V314.665C405.5 313.139 406.048 311.669 407.036 310.519C408.023 311.669 408.571 313.139 408.571 314.665Z"
        stroke="#02C874"
      />
      <line
        x1="394.107"
        y1="275.357"
        x2="419.893"
        y2="275.357"
        stroke="#02C874"
      />
      <line x1="391" y1="268.5" x2="423" y2="268.5" stroke="#02C874" />
      <line
        x1="388.678"
        y1="261.786"
        x2="425.321"
        y2="261.786"
        stroke="#02C874"
      />
      <line x1="388.678" y1="255" x2="425.321" y2="255" stroke="#02C874" />
      <line
        x1="388.678"
        y1="248.214"
        x2="425.321"
        y2="248.214"
        stroke="#02C874"
      />
      <line
        x1="390.036"
        y1="241.429"
        x2="423.964"
        y2="241.429"
        stroke="#02C874"
      />
      <line x1="394" y1="234.5" x2="420" y2="234.5" stroke="#02C874" />
      <line
        x1="398.178"
        y1="282.143"
        x2="415.821"
        y2="282.143"
        stroke="#02C874"
      />
      <line
        x1="402.25"
        y1="288.929"
        x2="411.75"
        y2="288.929"
        stroke="#02C874"
      />
    </g>
    <g clipPath="url(#clip5_155_2643)">
      <circle cx="412.304" cy="55.3206" r="55.3194" fill="#F2FCF8" />
      <path
        d="M454.389 54.7196C445.945 74.679 433.285 96.1737 412.935 96.1737C392.584 96.1737 380.693 80.4439 380.693 60.0932C380.693 42.4369 386.834 30.9218 392.975 20.1744C394.291 17.8716 399.884 16.3362 400.652 21.7099C401.705 30.7565 392.975 52.4167 400.652 57.0227C408.329 61.6288 419.844 37.0633 426.753 23.2453C428.672 19.4069 436.732 23.2453 435.197 28.619C439.035 27.0836 443.874 30.922 442.106 37.0633C445.327 36.2582 450.551 39.3663 447.48 47.8107C452.854 47.043 455.688 51.6491 454.389 54.7196Z"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M397.581 44.74C408.329 41.6693 413.703 47.8106 413.703 47.8106"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M400.009 31.8349C412.918 29.4398 419.776 35.6419 419.776 35.6419"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M400.009 31.8349C412.918 29.4398 419.776 35.6419 419.776 35.6419"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M400.009 20.8032C416.293 19.0831 425.35 25.725 425.35 25.725"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M435.197 28.6191C428.542 43.9725 418.309 57.7905 418.309 57.7905"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M442.358 35.528C435.703 50.8815 425.469 64.6994 425.469 64.6994"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M447.48 47.8107C441.475 62.1904 431.403 73.4573 431.403 73.4573"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="380.693"
        y1="59.529"
        x2="388.369"
        y2="59.529"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M381.46 69.3055L389.137 68.5378"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M384.531 78.5174L391.44 76.2144"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M390.672 87.7296L396.046 82.356"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M399.884 93.1033L402.955 86.9619"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M410.632 96.1739V89.2649"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
    </g>
    <g clipPath="url(#clip6_155_2643)">
      <circle cx="233.927" cy="486.586" r="55.3194" fill="#F2FCF8" />
      <circle
        cx="209.168"
        cy="512.316"
        r="6.37282"
        fill="#F2FCF8"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <circle
        cx="209.168"
        cy="512.316"
        r="1.74795"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <circle
        cx="225.817"
        cy="512.316"
        r="6.37282"
        fill="#F2FCF8"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <circle
        cx="225.817"
        cy="512.316"
        r="1.74795"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <circle
        cx="242.467"
        cy="512.316"
        r="6.37282"
        fill="#F2FCF8"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <circle
        cx="242.466"
        cy="512.316"
        r="1.74795"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <circle
        cx="259.116"
        cy="512.316"
        r="6.37282"
        fill="#F2FCF8"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <circle
        cx="259.116"
        cy="512.316"
        r="1.74795"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M227.997 453.845C221.06 456.322 208.672 459.295 208.672 459.295V467.224C208.672 470.692 203.717 479.116 203.717 489.027C203.717 498.937 210.654 503.397 210.654 503.397H259.711C259.711 503.397 266.153 498.442 266.153 492.495C266.153 486.549 262.188 484.072 259.711 483.576C257.233 483.08 254.26 483.576 249.8 482.585C245.341 481.594 230.97 467.719 227.997 453.845Z"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="231.193"
        y1="463.779"
        x2="224.256"
        y2="466.752"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="235.157"
        y1="469.725"
        x2="228.22"
        y2="472.698"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="240.119"
        y1="474.677"
        x2="231.2"
        y2="478.641"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M204.212 487.045C226.269 487.045 227.32 495.964 265.657 495.964"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M203.786 502.97H266.084V507.788H203.786V502.97Z"
        fill="#F2FCF8"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
    </g>
    <g clipPath="url(#clip7_155_2643)">
      <circle cx="233.927" cy="270.953" r="55.3194" fill="#F2FCF8" />
      <path
        d="M234.355 303.601L234.344 303.617L234.335 303.634L212.903 343.958C208.999 351.303 199.782 353.947 192.578 349.788C185.374 345.628 183.055 336.324 187.464 329.27L211.669 290.548L211.68 290.532L211.689 290.514L233.771 249.042C237.681 241.697 246.901 239.056 254.107 243.217C261.313 247.377 263.635 256.682 259.23 263.741L234.355 303.601Z"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M230.137 295.522C230.885 298.313 231.135 300.872 230.642 302.862C230.162 304.803 228.976 306.219 226.736 306.819C224.495 307.42 222.76 306.786 221.373 305.345C219.952 303.868 218.889 301.527 218.141 298.737C217.394 295.946 217.144 293.387 217.636 291.398C218.117 289.456 219.302 288.04 221.543 287.44C223.783 286.839 225.518 287.473 226.905 288.914C228.326 290.391 229.389 292.732 230.137 295.522Z"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M217.859 316.789C218.606 319.579 218.856 322.138 218.364 324.128C217.883 326.07 216.698 327.485 214.457 328.086C212.217 328.686 210.482 328.053 209.095 326.611C207.674 325.134 206.611 322.794 205.863 320.003C205.115 317.213 204.866 314.654 205.358 312.664C205.838 310.722 207.024 309.306 209.265 308.706C211.505 308.106 213.24 308.739 214.627 310.18C216.048 311.657 217.111 313.998 217.859 316.789Z"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M228.826 259.908L246.128 258.165L252.78 273.738"
        stroke="#02C874"
        strokeWidth="1.12897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M225.157 266.263L242.459 264.52L249.111 280.093"
        stroke="#02C874"
        strokeWidth="1.12897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="228.417"
        y1="290.768"
        x2="217.622"
        y2="293.661"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="215.999"
        y1="312.278"
        x2="205.204"
        y2="315.17"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="229.808"
        y1="292.875"
        x2="217.471"
        y2="296.18"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="217.39"
        y1="314.384"
        x2="205.052"
        y2="317.69"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
    </g>
    <g clipPath="url(#clip8_155_2643)">
      <circle cx="233.927" cy="55.3206" r="55.3194" fill="#F2FCF8" />
      <path
        d="M210.373 148.883L202.773 144.495L220.962 112.99C222.771 109.857 226.654 101.479 230.519 93.1408L230.543 93.0889C234.432 84.6989 238.298 76.3601 240.077 73.278L271.444 18.9497C273.567 15.2717 278.27 14.0116 281.948 16.1351C285.626 18.2586 286.886 22.9616 284.763 26.6396L253.396 80.9678C251.617 84.0504 246.199 91.7908 240.814 99.464C240.598 99.7716 240.382 100.079 240.167 100.386C235.029 107.707 230.056 114.792 228.563 117.378L210.373 148.883Z"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="235.522"
        y1="83.34"
        x2="246.96"
        y2="89.9435"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <mask
        id="mask1_155_2643"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x="220"
        y="15"
        width="24"
        height="24"
      >
        <circle cx="231.846" cy="27.2632" r="11.6172" fill="black" />
      </mask>
      <g mask="url(#mask1_155_2643)">
        <circle
          cx="231.846"
          cy="27.2632"
          r="11.0527"
          stroke="#02C874"
          strokeWidth="1.12897"
        />
        <circle
          cx="244.916"
          cy="27.2632"
          r="11.0527"
          stroke="#02C874"
          strokeWidth="1.12897"
        />
        <circle
          cx="218.777"
          cy="27.2632"
          r="11.0527"
          stroke="#02C874"
          strokeWidth="1.12897"
        />
      </g>
    </g>
    <g clipPath="url(#clip9_155_2643)">
      <circle cx="55.5503" cy="486.585" r="55.3194" fill="#F2FCF8" />
      <rect
        x="43.2832"
        y="484.035"
        width="3.98611"
        height="32.6305"
        transform="rotate(30 43.2832 484.035)"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <rect
        x="44.3328"
        y="504.722"
        width="7.05515"
        height="10.1242"
        transform="rotate(30 44.3328 504.722)"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="45.2454"
        y1="484.516"
        x2="89.7465"
        y2="407.438"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M55.4768 470.993C55.9268 471.253 56.4261 471.38 56.8849 471.35C57.339 471.321 57.8234 471.127 58.0883 470.668C58.3533 470.209 58.2796 469.692 58.078 469.284C57.8742 468.872 57.5143 468.503 57.0643 468.243C56.6143 467.983 56.115 467.856 55.6562 467.886C55.2021 467.915 54.7177 468.11 54.4528 468.569C54.1878 469.028 54.2615 469.544 54.4632 469.952C54.6669 470.364 55.0268 470.733 55.4768 470.993Z"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M67.2413 450.616C67.6914 450.876 68.1906 451.003 68.6494 450.973C69.1035 450.944 69.5879 450.75 69.8529 450.291C70.1178 449.832 70.0442 449.315 69.8425 448.907C69.6387 448.495 69.2789 448.126 68.8288 447.866C68.3788 447.606 67.8796 447.479 67.4207 447.509C66.9666 447.538 66.4823 447.733 66.2173 448.192C65.9523 448.651 66.026 449.167 66.2277 449.575C66.4315 449.987 66.7913 450.356 67.2413 450.616Z"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M79.0059 430.239C79.4559 430.499 79.9551 430.626 80.4139 430.596C80.868 430.567 81.3524 430.372 81.6174 429.913C81.8824 429.454 81.8087 428.938 81.607 428.53C81.4032 428.118 81.0434 427.749 80.5934 427.489C80.1433 427.229 79.6441 427.102 79.1853 427.132C78.7312 427.161 78.2468 427.355 77.9818 427.814C77.7168 428.273 77.7905 428.79 77.9922 429.198C78.196 429.61 78.5558 429.979 79.0059 430.239Z"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="41.9654"
        y1="506.777"
        x2="49.8473"
        y2="511.328"
        stroke="#02C874"
        strokeWidth="1.12897"
        strokeLinecap="round"
      />
      <path
        d="M47.7706 511.962L49.2684 517.552"
        stroke="#02C874"
        strokeWidth="1.12897"
        strokeLinecap="round"
      />
      <line
        x1="50.8223"
        y1="514.966"
        x2="48.3178"
        y2="519.304"
        stroke="#02C874"
        strokeWidth="1.12897"
        strokeLinecap="round"
      />
      <path
        d="M38.6234 500.184L38.0752 509.317L40.7331 510.852"
        stroke="#02C874"
        strokeWidth="1.12897"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip10_155_2643)">
      <circle cx="55.5503" cy="270.952" r="55.3194" fill="#F2FCF8" />
      <path
        d="M9.73924 276.103C9.73924 276.103 2.82087 266.271 14.4729 254.619C26.1248 242.967 35.9562 249.886 35.9562 249.886C41.4181 255.348 37.0486 262.63 47.9723 273.554C51.9777 277.559 51.2494 284.113 47.6082 287.755C43.9669 291.396 37.7768 292.488 33.4073 288.119C22.4836 277.195 15.5652 281.929 9.73924 276.103Z"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M48.3366 273.918C48.3366 273.918 48.7007 280.108 44.3312 284.477C39.9617 288.847 33.7716 288.483 33.7716 288.483"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="14.8364"
        y1="254.419"
        x2="38.1404"
        y2="254.419"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="9.01111"
        y1="261.701"
        x2="41.0541"
        y2="261.701"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="7.5542"
        y1="268.984"
        x2="43.9666"
        y2="268.984"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="9.73938"
        y1="276.994"
        x2="48.8756"
        y2="276.994"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="27.9452"
        y1="283.549"
        x2="45.4535"
        y2="283.549"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        y1="-0.564483"
        x2="21.1129"
        y2="-0.564483"
        transform="matrix(0 1 1 0 13.741 256.079)"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        y1="-0.564483"
        x2="29.8671"
        y2="-0.564483"
        transform="matrix(0 1 1 0 20.663 250.614)"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        y1="-0.564483"
        x2="35.5315"
        y2="-0.564483"
        transform="matrix(0 1 1 0 27.9453 247.701)"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        y1="-0.564483"
        x2="39.1362"
        y2="-0.564483"
        transform="matrix(0 1 1 0 35.1338 249.252)"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        y1="-0.564483"
        x2="16.4784"
        y2="-0.564483"
        transform="matrix(0 1 1 0 42.5104 269.548)"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M46.152 289.211L118.249 361.308L121.162 358.395L49.065 286.298"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M76.3666 249.573C76.3666 249.573 86.198 242.655 97.8499 254.307C109.502 265.959 102.584 275.79 102.584 275.79C97.1217 281.252 89.8392 276.883 78.9155 287.806C74.9101 291.812 68.3559 291.084 64.7146 287.442C61.0734 283.801 59.981 277.611 64.3505 273.241C75.2742 262.318 70.5406 255.399 76.3666 249.573Z"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M78.5516 288.17C78.5516 288.17 72.3614 288.535 67.9919 284.165C63.6224 279.796 63.9866 273.605 63.9866 273.605"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="98.0509"
        y1="254.671"
        x2="98.0509"
        y2="277.975"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="90.7686"
        y1="248.845"
        x2="90.7686"
        y2="280.888"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="83.4859"
        y1="247.388"
        x2="83.4859"
        y2="283.801"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="75.4746"
        y1="249.573"
        x2="75.4746"
        y2="288.709"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="68.9212"
        y1="267.78"
        x2="68.9212"
        y2="285.288"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        y1="-0.564483"
        x2="21.1129"
        y2="-0.564483"
        transform="matrix(-1 0 0 1 96.39 253.576)"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        y1="-0.564483"
        x2="29.8671"
        y2="-0.564483"
        transform="matrix(-1 0 0 1 101.855 260.497)"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        y1="-0.564483"
        x2="35.5315"
        y2="-0.564483"
        transform="matrix(-1 0 0 1 104.768 267.78)"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        y1="-0.564483"
        x2="39.1362"
        y2="-0.564483"
        transform="matrix(-1 0 0 1 103.217 274.968)"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        y1="-0.564483"
        x2="16.4784"
        y2="-0.564483"
        transform="matrix(-1 0 0 1 82.9205 282.345)"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M-5.92571 360.995L66.1709 288.899L63.2579 285.986L-8.8387 358.082L-5.92571 360.995Z"
        fill="#F2FCF8"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
    </g>
    <g clipPath="url(#clip11_155_2643)">
      <circle cx="55.5503" cy="55.3194" r="55.3194" fill="#F2FCF8" />
      <ellipse
        cx="53.9781"
        cy="35.8079"
        rx="17.0154"
        ry="6.80616"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M36.9628 36.375V47.1514C36.9628 50.9104 44.5808 53.9576 53.9782 53.9576C63.3755 53.9576 70.9936 50.9104 70.9936 47.1514V36.375"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <path
        d="M32.4754 80.3998C30.5057 74.6698 34.763 68.7044 40.8221 68.7044H67.0233C73.8295 68.7044 78.9341 65.3013 80.0685 60.7639C81.0981 56.6452 95.2128 -3.08449 97.8093 -14.0745C98.05 -15.0935 98.9579 -15.8054 100.005 -15.8054H101.088C102.528 -15.8054 103.606 -14.5037 103.299 -13.0962C100.465 -0.101159 88.3091 55.5266 86.3074 63.0326C84.0387 71.5403 80.0685 82.3167 64.1874 84.5855L41.4991 86.3307C37.4916 86.639 33.782 84.2008 32.4754 80.3998V80.3998Z"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="43.1996"
        y1="68.7043"
        x2="43.1996"
        y2="86.8541"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
      <line
        x1="64.7521"
        y1="69.2717"
        x2="64.7521"
        y2="84.0184"
        stroke="#02C874"
        strokeWidth="1.12897"
      />
    </g>
    <text
      fill="black"
      xmlSpace="preserve"
      fontFamily="Roboto"
      fontSize="18"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="557.724" y="577.996">
        Coolers
      </tspan>
    </text>
    <text
      fill="black"
      xmlSpace="preserve"
      fontFamily="Roboto"
      fontSize="18"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="541.385" y="362.363">
        Camping &#38;{' '}
      </tspan>
      <tspan x="559.722" y="386.071">
        Hiking
      </tspan>
    </text>
    <text
      fill="black"
      xmlSpace="preserve"
      fontFamily="Roboto"
      fontSize="18"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="568.326" y="146.73">
        Golf
      </tspan>
    </text>
    <text
      fill="black"
      xmlSpace="preserve"
      fontFamily="Roboto"
      fontSize="18"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="370.444" y="577.996">
        Premium{' '}
      </tspan>
      <tspan x="365.24" y="601.704">
        Outerwear
      </tspan>
    </text>
    <text
      fill="black"
      xmlSpace="preserve"
      fontFamily="Roboto"
      fontSize="18"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="344.837" y="362.363">
        Racquet Sports
      </tspan>
    </text>
    <text
      fill="black"
      xmlSpace="preserve"
      fontFamily="Roboto"
      fontSize="18"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="375.201" y="146.73">
        Softball
      </tspan>
    </text>
    <text
      fill="black"
      xmlSpace="preserve"
      fontFamily="Roboto"
      fontSize="18"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="198.979" y="577.996">
        Fitness
      </tspan>
    </text>
    <text
      fill="black"
      xmlSpace="preserve"
      fontFamily="Roboto"
      fontSize="18"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="177.664" y="362.363">
        Snow Sports
      </tspan>
    </text>
    <text
      fill="black"
      xmlSpace="preserve"
      fontFamily="Roboto"
      fontSize="18"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="193.666" y="146.73">
        Baseball
      </tspan>
    </text>
    <text
      fill="black"
      xmlSpace="preserve"
      fontFamily="Roboto"
      fontSize="18"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="20.6551" y="577.996">
        Fishing
      </tspan>
    </text>
    <text
      fill="black"
      xmlSpace="preserve"
      fontFamily="Roboto"
      fontSize="18"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="12.8434" y="362.363">
        Lacrosse
      </tspan>
    </text>
    <text
      fill="black"
      xmlSpace="preserve"
      fontFamily="Roboto"
      fontSize="18"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="19.8381" y="146.73">
        Hockey
      </tspan>
    </text>
    <defs>
      <clipPath id="clip0_155_2643">
        <rect
          x="535.361"
          y="431.265"
          width="110.639"
          height="110.639"
          rx="55.3194"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_155_2643">
        <rect
          x="535.361"
          y="215.633"
          width="110.639"
          height="110.639"
          rx="55.3194"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip2_155_2643">
        <rect
          x="535.361"
          width="110.639"
          height="110.639"
          rx="55.3194"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip3_155_2643">
        <rect
          x="356.984"
          y="431.265"
          width="110.639"
          height="110.639"
          rx="55.3194"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip4_155_2643">
        <rect
          x="356.984"
          y="215.633"
          width="110.639"
          height="110.639"
          rx="55.3194"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip5_155_2643">
        <rect
          x="356.984"
          width="110.639"
          height="110.639"
          rx="55.3194"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip6_155_2643">
        <rect
          x="178.608"
          y="431.265"
          width="110.639"
          height="110.639"
          rx="55.3194"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip7_155_2643">
        <rect
          x="178.608"
          y="215.633"
          width="110.639"
          height="110.639"
          rx="55.3194"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip8_155_2643">
        <rect
          x="178.608"
          width="110.639"
          height="110.639"
          rx="55.3194"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip9_155_2643">
        <rect
          x="0.230957"
          y="431.265"
          width="110.639"
          height="110.639"
          rx="55.3194"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip10_155_2643">
        <rect
          x="0.230957"
          y="215.633"
          width="110.639"
          height="110.639"
          rx="55.3194"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip11_155_2643">
        <rect
          x="0.230957"
          width="110.639"
          height="110.639"
          rx="55.3194"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
));
